// src/components/SidebarToggle.js
import { useSidebar } from "../../context/SidebarContext";
import { Menu, ChevronLeft, ChevronRight } from "@mui/icons-material";

const SidebarToggle = () => {
  const { isCollapsed, toggleSidebar } = useSidebar();

  return (
    <>
      {/* Mobile Toggle */}
      <button
        onClick={toggleSidebar}
        className="top-4 left-4 z-50 p-2 rounded-md bg-white"
      >
        <Menu className="text-[#7451f8]" />
      </button>

      {/* Desktop Toggle */}
      {/* <button
        onClick={toggleSidebar}
        className="hidden md:inline-block top-4 left-4 z-50 p-2 rounded-md bg-[#7451f8] text-white"
      >
        {isCollapsed ? <ChevronRight /> : <ChevronLeft />}
      </button> */}
    </>
  );
};

export default SidebarToggle;
